module.exports = __webpack_public_path__ + "img/req_yi.e46688fa.png";